import { API_BASE_URL } from '../../config/api';
import apiCache from '../../lib/apiCache';

const UserData = {
    fetch: async (email) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/profile?email=${email}`);
            const data = await response.json();
            //console.log('Raw data from server:', data);
            
            const padreData = data.Padre?.[0] || {};
            const amateurData = data.Amateur?.[0] || {};
            //console.log('Padre data:', padreData);
            //console.log('Amateur data:', amateurData);
            
            // Safely split the apellidos if they exist
            const apellidos = amateurData.AmateurApellidos ? amateurData.AmateurApellidos.split(' ') : ['', ''];
            const apaternoAmateur = apellidos[0] || '';
            const amaternoAmateur = apellidos[1] || '';
            
            const userData = {
                email: email,
                padcodigo: padreData.padcodigo || '',
                amcodigo: amateurData.AmateurCodigo || '',
                nombre: padreData.padnombre || amateurData.AmateurNombre || '',
                apellidoPaterno: padreData.padappaterno || apaternoAmateur || '',
                apellidoMaterno: padreData.padapmaterno || amaternoAmateur || '',
                calle: padreData.padcalle || '',
                numeroExterior: padreData.padnroexterior || '',
                numeroInterior: padreData.padnrointerior || '',
                codigoPostal: padreData.cpcodigo || '',
                colonia: padreData.cpcolonia || '',
                telefono: padreData.patelcasa || amateurData.AmateurTelefono || '',
                celular: padreData.pateloficina || amateurData.AmateurCelular || '',
                otroEmail: padreData.madmail || ''
            };
            
            //console.log('Processed user data:', userData);
            return userData;
        } catch (error) {
            console.error('Error fetching data:', error);
            return {
                email: email,
                nombre: '',
                apellidoPaterno: '',
                apellidoMaterno: '',
                calle: '',
                numeroExterior: '',
                numeroInterior: '',
                codigoPostal: '',
                colonia: '',
                telefono: '',
                celular: '',
                otroEmail: ''
            };
        }
    },

    update: async (userData) => {
        try {
          const response = await fetch(`${API_BASE_URL}/api/profile/update`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(userData),
          });
      
          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || 'Failed to update user data');
          }

          apiCache.invalidate('hijos:');
          return await response.json();
        } catch (error) {
          console.error('Error updating user data:', error);
          throw error;
        }
      },

    create: async (userData) => {
        try {
          const response = await fetch(`${API_BASE_URL}/api/profile/create`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(userData),
          });
      
          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || 'Failed to create user profile');
          }

          apiCache.invalidate('hijos:');
          return await response.json();
        } catch (error) {
          console.error('Error creating user profile:', error);
          throw error;
        }
      }      
};

export default UserData;
